<script lang="ts">
	// UI
	import StoreChange from "../v7/components/common/StoreChange.svelte";
	//Utils
	import { navigate } from "svelte-routing";
	import { onDestroy, onMount } from "svelte";
	import { logout } from "../functions/auth/logout";
	import { t } from "@hitit/hub/src/stores";
	import {
		allStoreMode,
		popup,
		storeIds,
		accessControlList,
		storeLogos,
	} from "../v7/store";
	import type { AccessControlDTO } from "@hitit/api";

	//Props
	export let open = false;
	export let linkClickAfterHanlder = () => {};

	//Variables
	const defaultImage = storeLogos.getDefaultImage();
	const BASE_URL = "HITIT_BACKEND_URL";
	const srcPrefix = "/img/side-bar/";
	const storeChangeCancel = () => ($popup = undefined);
	const event = (e: Event) => {
		const t = e.target as HTMLElement;

		if (sideaccount === t || sideaccount.contains(t) || open === false) {
			return;
		}

		open = false;
	};
	// Variables
	let sideaccount: HTMLDivElement;
	$: logoImage = getImage($storeIds, $storeLogos);
	$: controler = [
		{
			id: "profile",
			src: srcPrefix + "Profile.png",
			callback: () => {
				linkClickAfterHanlder();
				navigate("/profile");
			},
			name: $t("global.profile"),
		},
		{
			id: "storechange",
			src: srcPrefix + "StoreChange.png",
			callback: () => {
				linkClickAfterHanlder();
				$popup = {
					component: StoreChange,
					props: {
						selectedStoreIds: $storeIds,
						accept: (ids: string) => {
							$storeIds = ids;
							storeChangeCancel();
						},
						storeNameIds:
							$accessControlList?.map((v) => ({
								name: v.storename,
								id: v.storeId,
								permission: v.permission,
							})) || [],
						cancel: storeChangeCancel,
					},
				};
			},
			name: $t("global.store_change"),
		},
		{
			id: "logout",
			src: srcPrefix + "Logout.png",
			callback: () => logout(`${BASE_URL}logout`),
			name: $t("global.logout"),
			topDivider: true,
		},
	];

	function getStoreName(
		accessControlDTOList: AccessControlDTO[],
		storeId: string
	) {
		const find = accessControlDTOList.find((v) => v.storeId === storeId);
		return find?.storename || "";
	}

	function getImage(
		storeId?: string,
		storeLogos?: { image: string; storeId: string }[]
	) {
		const find = storeLogos?.find((v) => v.storeId === storeId);
		if (!(storeLogos && storeId) || !find) {
			return defaultImage;
		}

		return find.image;
	}

	onMount(() => window.addEventListener("click", event));
	onDestroy(() => window.removeEventListener("click", event));

</script>

<div
	bind:this={sideaccount}
	on:click={() => (open = !open)}
	id="sideaccount"
	class:open>
	<div class="profile-box">
		{#if $allStoreMode}
			<img src={'/img/icons/allStore.png'} alt="All Store Icon" />
			<h3>{$t('hub.app.all_store')}</h3>
		{:else}
			<img src={logoImage} alt="" />
			<h3>{getStoreName($accessControlList || [], $storeIds)}</h3>
		{/if}
	</div>
	<div class="control-box" class:open>
		{#each controler as control}
			<div
				class="control"
				class:topDivider={control.topDivider}
				on:click={control.callback}>
				<div class="icon-box">
					<img id={control.id} src={control.src} alt="logo" />
				</div>
				<span>{control.name}</span>
			</div>
		{/each}
	</div>
</div>

<style lang="scss">
	@import "../variables.scss";
	//Mobile First
	#sideaccount {
		position: absolute;
		z-index: 999;
		top: 0;
		left: 0;
		width: calc(100% - 20px);
		background-color: #f0f0f4;
		border-radius: 0 5px 5px 0;
		max-height: 80px;
		overflow-y: hidden;
		transition: max-height 0.6s cubic-bezier(0, 1, 0, 1);
		&:hover {
			cursor: pointer;
			box-shadow: 3px 3px 0px 2px rgba(59, 59, 59, 0.63);
		}

		&.open {
			max-height: 300px;
			transition: max-height 0.6s ease-in-out;
		}

		.control-box {
			display: flex;
			flex-direction: column;
			gap: 10px;
			box-sizing: border-box;
			padding-bottom: 20px;
			.icon-box {
				width: 20px;
				height: 19.5px;
				position: relative;
				img {
					position: absolute;
					left: 50%;
					top: 50%;
					transform: translate(-50%, -50%);
					object-fit: contain;
					&#profile {
						width: 15.3px;
						height: 26px;
					}

					&#storechange {
						width: 26.7px;
						height: 26px;
					}

					&#logout {
						width: 23px;
						height: 23.2px;
					}
				}
			}

			.control {
				padding-left: 40px;
				gap: 30px;
				padding-top: 10px;
				display: flex;
				align-items: center;
				height: 20px;
				color: var(--grey5);
				transition: color 0.5s;

				&:hover {
					cursor: pointer;
					color: var(--signature-blue);
				}

				&.topDivider {
					border-top: 1px solid var(--lightGrey2);
				}
			}
		}

		.profile-box {
			display: flex;
			box-sizing: border-box;
			gap: 10px;
			padding: 10px 20px;
			width: 100%;
			height: 80px;

			img {
				width: 60px;
				height: 60px;
				border-radius: 999px;
			}

			h3 {
				display: flex;
				font-size: 1.25rem;
				flex-grow: 1;
				color: var(--background-1);
				font-weight: 550;
				height: 100%;
				align-items: center;
			}
		}
	}

	@include DesktopSize {
		#sideaccount {
			max-height: 60px;

			.profile-box {
				display: flex;
				box-sizing: border-box;
				gap: 10px;
				padding: 10px;
				padding-left: 50px;
				width: 100%;
				height: 60px;

				img {
					width: 40px;
					height: 40px;
					border-radius: 999px;
				}

				h3 {
					display: flex;
					font-size: 1.25rem;
					flex-grow: 1;
					color: var(--background-1);
					font-weight: 550;
					height: 100%;
					align-items: center;
				}
			}

			.control-box {
				gap: 21px;
				box-sizing: border-box;
				padding-bottom: 20px;
				.icon-box {
					width: 26.7px;
					height: 26px;
					img {
						position: absolute;
						left: 50%;
						top: 50%;
						transform: translate(-50%, -50%);
					}
				}

				.control {
					padding-left: 56.6px;
					gap: 16.6px;
					display: flex;
					align-items: center;
					height: 26px;
					color: var(--grey5);
					transition: color 0.5s;
					font-size: 1.25rem;

					&:hover {
						cursor: pointer;
						color: var(--signature-blue);
					}

					&.topDivider {
						padding-top: 20px;
						border-top: 1px solid var(--lightGrey2);
					}
				}
			}
		}
	}

</style>
